// Enums base compartidos backend ↔ frontend.
// El backend los reusa para validar contra Prisma (que también los genera).
// El frontend los usa para selects, validaciones de form y mapeo i18n.
export const ROLES = ['ADMINISTRADOR', 'GERENCIA', 'LIDER', 'COLABORADOR', 'VISUALIZADOR'];
export const PROVEEDORES_AUTH = ['LOCAL', 'AD'];
// --- Dominio Agente-Ventas: leads y mensajes (SPEC §6) ---------------------
export const ESTADOS_LEAD = [
    'NUEVO',
    'ACTIVO',
    'ESPERANDO_RESPUESTA',
    'RECONTACTO_1',
    'RECONTACTO_2',
    'CERRADO_GANADO',
    'CERRADO_NO_INTERESADO',
    'CERRADO_SIN_RESPUESTA',
    'DERIVADO_SALUD',
    // Importado del historial de Evolution (Ciclo 1b): no figura en los estados
    // de trabajo; si la persona escribe de nuevo pasa a NUEVO.
    'HISTORICO',
    // Eliminado a mano (motivo obligatorio): oculto de la bandeja, nunca se le
    // vuelve a escribir. Un mensaje entrante no lo reabre (a diferencia de los
    // CERRADO_*). Se refleja en Notion Master Leads como Estado: Bloqueado.
    'BLOQUEADO',
];
export const ESTADOS_LEAD_CERRADOS = [
    'CERRADO_GANADO',
    'CERRADO_NO_INTERESADO',
    'CERRADO_SIN_RESPUESTA',
    'DERIVADO_SALUD',
];
export const FUENTES_LEAD = ['META_ADS', 'ORGANICO', 'RECONTACTO_CAMPANA'];
// Cómo se decidió la fuente al crear el lead (FR-02). Se guarda para medir.
// FALLBACK ya no se produce (Ciclo 1b): queda por los leads viejos. VIGENCIA = una
// campaña de reapertura vigente en esa instancia al llegar el primer mensaje.
// PLANTILLA = un saliente nuestro coincidió con una plantilla de la campaña (Ciclo 1c).
export const DETECCIONES_FUENTE = [
    'AD_METADATA',
    'TEXTO',
    'PLANTILLA',
    'VIGENCIA',
    'FALLBACK',
    'NINGUNA',
];
// Campañas como datos (Ciclo 1b). META_ADS se reconoce por el texto del anuncio o
// el metadato; REAPERTURA (el Emisor de n8n) por vigencia en la instancia.
// EMISION (ciclo-emisor) = una campaña que manda la app; no atribuye leads entrantes.
export const TIPOS_CAMPANA = ['META_ADS', 'REAPERTURA', 'EMISION'];
// Las que se crean desde el formulario de atribución (la de envío tiene su propio armado).
export const TIPOS_CAMPANA_ATRIBUCION = ['META_ADS', 'REAPERTURA'];
export const DIRECCIONES_MENSAJE = ['IN', 'OUT'];
export const TIPOS_MENSAJE = ['TEXTO', 'AUDIO', 'IMAGEN', 'VIDEO', 'DOCUMENTO', 'STICKER', 'OTRO'];
// Quién originó cada mensaje. OPERADORA = la usuaria de la app (Ailen);
// TELEFONO = alguien contestó desde el celular; RECONTACTO_AUTO = el cron (Ciclo 3,
// todavía sin construir); SISTEMA_APERTURA = el mensaje fijo de Etapa 1 auto-enviado
// por el sistema, sin LLM, bajo candado+horario+interruptor (D-027).
// CAMPANA = el mensaje de una campaña de envío (ciclo-emisor).
export const ENVIADO_POR = [
    'LEAD',
    'OPERADORA',
    'RECONTACTO_AUTO',
    'TELEFONO',
    'SISTEMA_APERTURA',
    'CAMPANA',
];
export const MOTIVOS_CIERRE = ['GANADO', 'NO_INTERESADO', 'SIN_RESPUESTA', 'DERIVADO_SALUD'];
// Ciclo 2 — sugerencia de respuesta por LLM, solo leads META_ADS (D-023/024/025).
export const ESTADOS_SUGERENCIA = ['PENDIENTE', 'ENVIADA', 'EDITADA', 'DESCARTADA', 'OBSOLETA'];
// Candado de salud en dos capas (D-024): derivacion/crisis vienen de la lista
// determinística en código O del propio LLM (bandera_salud); screening es solo dato
// para Etapa 5, no bloquea nada.
export const BANDERAS_SALUD = ['no', 'derivacion', 'crisis'];
// ciclo-tareas: prioridad de una tarea recurrente de Ailen (rojo/amarillo/verde pastel).
export const PRIORIDADES_TAREA = ['ALTA', 'MEDIA', 'BAJA'];
// Circuito planificar/ejecutar/cerrar (28/09/2026): PLANIFICADA admite editar
// la lista de tareas (checks bloqueados); GUARDADA la congela (solo checks);
// CERRADA es historial para siempre, nace la semana siguiente en PLANIFICADA.
export const ESTADOS_SEMANA = ['PLANIFICADA', 'GUARDADA', 'CERRADA'];
// ciclo-calidad-leads (15/10/2026, capa 1 de la Fase M): si el lead valía la
// pena. Aparte del estado: el estado dice en qué punto está la charla, la
// calidad dice si servía. COMPRO lo pone solo el cierre GANADO (también a mano).
export const CALIDADES_LEAD = ['SIN_CALIFICAR', 'BUENO', 'BASURA', 'COMPRO'];
// Lista fija (Javier, 15/10): no editable desde la app porque las capas 2 y 3
// arman audiencias con esto. "Sin presupuesto" NO está a propósito: es una
// objeción, no un lead basura. Tampoco hay "Otro".
export const MOTIVOS_BASURA = [
    'DESINTERESADO',
    'BUSCA_OTRA_COSA',
    'FUERA_DE_ZONA',
    'SPAM',
    'INAPROPIADO',
];
//# sourceMappingURL=enums.js.map